import { OnboardingRepository } from "../repositories/OnboardingRepository";
import { SignupPhotoLivenessSaveResult } from "../entities/signupPhotoLiveness";

export interface SaveSignupPhotoLivenessResultParams {
	sessionId: string;
	contextToken: string;
}

export class SaveSignupPhotoLivenessResult {
	constructor(private repository: OnboardingRepository) {}

	execute(
		params: SaveSignupPhotoLivenessResultParams
	): Promise<SignupPhotoLivenessSaveResult> {
		return this.repository.saveSignupPhotoLivenessResult(params);
	}
}
